module.exports = __webpack_public_path__ + "img/channel_video_bg.f82ad6c3.jpg";